/** Where the session token lives (localStorage). */
export const authTokenLocalStorageKey = 'auth.token'
